import { ServiceBusController, ServiceManager, ServiceBusControllerBody } from '@estee/elc-service';
import { on, events, queryProvider, commandProvider } from '@estee/elc-service-bus';

// Reserved so we won't forget to register them in the future
const queries: string[][] = [];
const commands: string[][] = [];
const onEvents: string[][] = [[events.RAMP_LOG_IN_FAILED, 'handleFailedRampLogIn']];

class ServiceBus extends ServiceBusController {
    @on(events.ECOMM_STARTED, { replay: true })
    public onEcommStarted = () => {
        queries.forEach(ServiceManager.setDecoratorOnFunction(queryProvider));
        onEvents.forEach(ServiceManager.setDecoratorOnFunction(on));
        commands.forEach(ServiceManager.setDecoratorOnFunction(commandProvider));
    };
}

export const serviceBusBaseClass = new ServiceBus() as ServiceBusController &
    ServiceBusControllerBody;
